import { useCallback } from 'react';
import { useQuery } from 'src/shared/lib/useQuery';
import { FEATURE_FLAGS, FeatureFlag } from 'src/shared/constants/featureFlags.constant';
import { useAuth } from 'src/features/auth/contexts/AuthContext';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { genQueryKey } from 'src/shared/lib/query.utils';

export function useFeatureFlag(flag: FeatureFlag | undefined) {
  const { apiFetch } = useAuth();
  const { currentOrg } = useOrg();

  const queryKey = flag ? [`ff:${FEATURE_FLAGS[flag]}`, genQueryKey(currentOrg.id)] : [];

  const select = useCallback((data: boolean) => data, []);

  return useQuery({
    queryKey: queryKey,
    queryFn: getData,
    select,
    enabled: !!currentOrg.id && !!flag,
    staleTime: 1000 * 60,
  });

  async function getData() {
    if (!flag) {
      throw new Error('Flag is required');
    }

    const res = await apiFetch<boolean>(`/api/v2/organisations/${currentOrg.id}/featureflags/${FEATURE_FLAGS[flag]}`);

    const data = await res.json();

    if (!res.ok) {
      throw new Error('Failed to fetch feature flag');
    }
    return data as boolean;
  }
}
